interface PropertyMetaData {
  title: string;
  description: string;
  imageUrl: string;
  url: string;
  address?: string;
}

/**
 * Updates meta tags dynamically for property tokens
 */
export const updateMetaTags = (data: PropertyMetaData) => {
  // Update page title
  document.title = data.title;

  // Helper function to update or create meta tag
  const updateMetaTag = (property: string, content: string, isProperty = true) => {
    const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
    let tag = document.querySelector(selector) as HTMLMetaElement;
    
    if (!tag) {
      tag = document.createElement('meta');
      if (isProperty) {
        tag.setAttribute('property', property);
      } else {
        tag.setAttribute('name', property);
      }
      document.head.appendChild(tag);
    }
    
    tag.content = content;
  };

  // Update OpenGraph tags
  updateMetaTag('og:title', data.title);
  updateMetaTag('og:description', data.description);
  updateMetaTag('og:image', data.imageUrl);
  updateMetaTag('og:url', data.url);
  updateMetaTag('og:type', 'website');

  // Update Twitter tags
  updateMetaTag('twitter:card', 'summary_large_image', false);
  updateMetaTag('twitter:title', data.title, false);
  updateMetaTag('twitter:description', data.description, false);
  updateMetaTag('twitter:image', data.imageUrl, false);
  updateMetaTag('twitter:url', data.url, false);

  // Update canonical URL
  let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.href = data.url;
};

/**
 * Generates property-specific meta data from property information
 */
export const generatePropertyMetaData = (property: any, token: string): PropertyMetaData => {
  const baseUrl = window.location.origin;
  const address = property.address || 'Property';
  
  // Use the best available image for social sharing
  const imageUrl = property.watercolor_image_url || 
                   property.pencil_image_url || 
                   property.oil_image_url || 
                   property.charcoal_image_url || 
                   property.chalk_image_url ||
                   property.master_image_url ||
                   `${baseUrl}/default-social-image.png`;

  return {
    title: `${address} - Beautiful Custom Artwork | Frame My Home`,
    description: `See this stunning custom artwork of ${address}. Transform your property photos into beautiful watercolor, pencil, or oil paintings with Frame My Home.`,
    imageUrl,
    url: `${baseUrl}/${token}`,
    address
  };
};

/**
 * Resets meta tags to default values
 */
export const resetMetaTagsToDefault = () => {
  updateMetaTags({
    title: 'Frame My Home - Transform Your Property Photos Into Beautiful Artwork',
    description: 'Transform your home photos into beautiful artwork',
    imageUrl: 'https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//social_image.png',
    url: window.location.origin
  });
}; 